<template>
  <td class="ui dimmable" :class="[ { 'dimmed': hovered } ]" @mouseover="hovered = true" @mouseleave="hovered = false"
      @click="select">
    <div class="ui simple dimmer" @click="toggleDropdown">
      <div class="content">
        <div class="center">
          <p><strong>{{ booking.status ? booking.status.toUpperCase() : 'OPEN' }}</strong></p>
          <p v-if="booking.reservation"><strong>{{ booking.reservation ? booking.reservation.contact.firstName
            + ' ' +
            booking.reservation.contact.lastName : '' }}</strong></p>
          <p v-if="booking.reservation"><strong>{{ booking.reservation.code }}</strong></p>
          <p v-if="!boat.startsAtHalfHour">{{ hour }} Uhr</p>
          <p v-else>
            {{ (parseInt(hour.split(' - ')[0]) - 1) + ':30' }} - {{ (parseInt(hour.split(' - ')[1]) - 1) + ':30' }}
          </p>
        </div>
      </div>
    </div>
    <div :class="[
      booking.status,
      { 'create-selected': createSelected },
      {'unconfirmed': booking.reservation && !booking.reservation.confirmed},
      { 'ui dropdown': ['reserved', 'selected', 'blocked', 'open', 'readyToGo', 'boatOut', 'returned'].indexOf(booking.status) > -1 },
      { 'moving': moving }
      ]"
         class="booking-field">
      <!--<p>-->
        <!--<strong v-if="booking.status === 'open'">OPEN</strong>-->
        <!--<strong v-if="booking.status === 'reserved'">RESERVED</strong>-->
        <!--<strong v-if="booking.status === 'readyToGo'">READY</strong>-->
        <!--<strong v-if="booking.status === 'boatOut'">CURRENTLY OUT</strong>-->
        <!--<strong v-if="booking.status === 'returned'">BOAT RETURNED</strong>-->
      <!--</p>-->
      <p v-if="booking.status === 'blocked'">
        <strong>INTERNAL BLOCK</strong>
      </p>
      <p v-if="booking.reservation">{{ booking.reservation.contact.firstName }} {{ booking.reservation.contact.lastName }}</p>
      <p v-if="booking.reservation && booking.reservation.confirmed"><strong>{{ booking.reservation.code }}</strong></p>
      <table v-if="booking.reservation" style="margin-left: 10px; margin-right: 10px; border: 1px solid #fff; color: #fff">
        <tr>
          <td class="service letter" style="color: #fff" v-for="service in booking.reservation.services"><strong v-if="service.selected">{{ service.letter }}</strong></td>
          <td class="service letter"><strong v-if="booking.reservation.questions">Q</strong></td>
          <td class="service letter"><strong v-if="booking.reservation.wishes">W</strong></td>
        </tr>
      </table>
      <div style="text-align: left; padding-left: 5px; padding-right: 5px; color: #fff; font-size: 12px" v-if="booking.reservation">
        {{ booking.reservation.people }}
        <div style="float: right" v-if="booking.discount && booking.discount.voucher">
          {{ booking.discount.voucher }}
        </div>
      </div>
      <div class="ui mini label" v-if="booking.reservation && !booking.reservation.confirmed"><strong>UNCONFIRMED</strong></div>

      <div class="menu" v-if="booking.reservation">
        <div class="item" @click="viewDetails"><i class="info icon"></i> View Details</div>
        <div class="divider"></div>
        <div class="item" @click="goOut" v-if="booking.status === 'readyToGo'"><i class="sign out icon"></i> Boat Went Out</div>
        <div class="item" @click="returned" v-if="booking.status === 'boatOut'"><i class="sign in icon"></i> Boat Returned</div>
        <div class="item" @click="cancelBooking"><i class="delete icon"></i> Cancel This Booking Slot</div>
        <div class="item" @click="cancelReservation"><i class="delete icon"></i> Cancel Whole Reservation</div>
        <div class="item" @click="moveBooking"><i class="exchange icon"></i> Move Booking</div>
        <div class="item" @click="extendBooking"><i class="hourglass end icon"></i> Extend Booking</div>
      </div>
      <div class="menu" v-else-if="booking.status === 'open' || booking.status === 'selected'">
        <div class="item" @click="blockSlot"><i class="delete icon"></i> Block Booking Slot</div>
      </div>
      <div class="menu" v-else-if="booking.status === 'blocked'">
        <div class="item" @click="unblockSlot"><i class="checkmark icon"></i> Unblock Booking Slot</div>
      </div>
    </div>
    <!--<div class="ui ">

    </div>-->
  </td>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../services'

  export default {
    data() {
      return {
        hovered: false,
        booking: {
          _boat: this.boat._id,
          boat: this.boat,
          hour: this.hour,
          date: this.date,
          status: 'open',
          clientId: "admin"
        },
//        moving: false
      }
    },
    computed: {
      moving: function () {
        return this.move.status && this.move.booking == this.booking
      },
      createSelected: function () {
        return this.create.status && this.booking._id && this.create.selected.filter(booking => {return booking._id === this.booking._id}).length
      }
    },
    watch: {
      allBookings: function () {
        this.booking = {
          _boat: this.boat._id,
          boat: this.boat,
          hour: this.hour,
          date: this.date,
          status: 'open',
          clientId: "admin"
        }

        let thisBooking = this.allBookings.find(booking => {
          return booking.hour === this.hour && booking._boat === this.boat._id && booking.date === this.date
        })

        if (thisBooking) this.booking = thisBooking
      },
      updatedBooking: {
        deep: true,
        handler: function (newBooking) {
          if (newBooking) {
            if (newBooking._boat === this.boat._id && newBooking.hour === this.hour && newBooking.date === this.date) {
              this.booking = newBooking
              this.initDropdown()
            }
          }
        }
      },
    },
    mounted() {
      services.bookingService.find({
        query: {
          _boat: this.boat._id,
          hour: this.hour,
          date: this.date,
          $limit: 1
        }
      }).then(bookings => {
        if (bookings.data[0]) this.booking = bookings.data[0]
      })
    },
    methods: {
      initDropdown() {
        setTimeout(() => {
          $('.ui.dropdown').dropdown()
        }, 50)
      },
      toggleDropdown() {
        if (this.move.status == true) {
            this.moveToThis()
            return
        } else if (this.create.status === true) {
            this.selectThisForNew()
            return
        }

        $('#' + this.boat._id + '-' + this.hourIndex + ' .ui.dropdown').dropdown('toggle')
      },
      moveToThis() {

        console.log('MOVE TO THIS', this.booking);

        if (this.booking.status === 'open' || !this.booking.status) {
          this.$emit('moveTo', this.booking)
          return
        }

        if (this.booking.status === 'selected' && this.settings.adminOverridesSelected) {
          this.$emit('moveTo', this.booking)
          return
        }

        toastr.error('Selected booking slot is not free, please choose another one', 'Not allowed!')

      },
      selectThisForNew() {
        services.bookingService.find({ query: {
          '_boat': this.boat._id,
          'date': this.date,
          'hour': this.hour,
          $limit: 1
        }}).then((bookings) => {
          let oldBooking = null
          let bookingForSelect = this.booking

          if (bookings.data.length > 0) {
            oldBooking = bookings.data[0]
          }

          if (oldBooking) {
            if (oldBooking.status === 'open' || (oldBooking.status === 'selected' && this.settings.adminOverridesSelected)) {
              bookingForSelect.cost = this.boat.price
              this.$emit('selectForCreate', bookingForSelect)
              return
            }

            if (oldBooking.status === 'selected' && this.settings.adminOverridesSelected) {
              bookingForSelect.cost = this.boat.price
              this.$emit('selectForCreate', this.booking)
              return
            }

            throw new Error('Booking already selected')
          } else {
            services.bookingService.create({
              ...this.booking,
              status: 'open',
              cost: this.booking.boat.price,
            }).then(booking => {
              this.$emit('selectForCreate', booking)
            })
          }

        }).catch(e => {
          toastr.error(e, 'Not allowed!')

          throw e
        })
      },
      /*acceptBooking() {
       services.bookingService.patch(this.booking._id, { status: 'accepted' }).then(booking => {
       toastr.success('Booking accepted')
       })
       },*/
      cancelBooking() {
        services.bookingService.patch(this.booking._id, {
          status: 'open',
          _reservation: null,
          discardedReservation: this.booking.reservation,
          clientId: 'admin'
        }).then(booking => {
          toastr.info('Booking cancelled')
        })
      },
      cancelReservation() {
        if (!this.booking.reservation) return

        services.reservationService.patch(this.booking.reservation._id, {
          status: 'cancelled',
          statusReason: 'adminAction'
        }).then(result => {
          toastr.info('Reservation cancelled')
        })
      },
      moveBooking() {
        this.$emit('moveBooking', this.booking)
        $('.ui.dropdown').dropdown('hide')
      },
      extendBooking() {
        services.bookingService.find({
          query: {
            _boat: this.boat._id,
            hour: this.hours[this.hourIndex + 1],
            date: this.date,
            $limit: 1
          }
        }).then(bookings => {
          if (bookings.data[0] && bookings.data[0].status !== 'open') {
            toastr.error('The next booking slot is not free!', 'Error extending')
            return
          }

          console.log(bookings.data);
          if (!bookings.data[0]) {
            let newBooking = {...this.booking};
            delete newBooking._id
            newBooking.hour = this.hours[this.hourIndex + 1]

            services.bookingService.create(newBooking).then(booking => {
              toastr.success('Booking was successfully extended!', 'Booking extended')
            })
          } else {
            let booking = bookings.data[0]

            services.bookingService.patch(booking._id, {...this.booking, _id: null, hour: this.hours[this.hourIndex + 1]}).then(booking => {
              toastr.success('Booking was successfully extended!', 'Booking extended')
            })
          }
        })
      },
      blockSlot() {
        if (this.booking.status === 'selected' && !this.settings.adminOverridesSelected) {
            toastr.error('Overriding currently selected booking slots is not allowed', 'Not Allowed')
          return
        }

        if (this.booking._id) {
          services.bookingService.patch(this.booking._id, { status: 'blocked' }).then(booking => {
            toastr.info('Booking slot blocked')
          })
        } else {
          services.bookingService.create({ ...this.booking, status: 'blocked' }).then(booking => {
            toastr.info('Booking slot blocked')
          })
        }
      },
      unblockSlot() {
        services.bookingService.patch(this.booking._id, { status: 'open' }).then(booking => {
          toastr.info('Booking slot unblocked')
        })
      },
      makeSlotOpen() {
        services.bookingService.patch(this.booking._id, { status: 'open' }).then(booking => {
          toastr.info('Booking slot reset')
        })
      },
      goOut() {
        services.reservationService.patch(this.booking._reservation, { status: 'inProgress' }).then(reservation => {
          for (let booking of reservation.bookings) {
            services.bookingService.patch(booking._id, { status: 'boatOut' })
          }
          services.boatService.patch(this.booking._boat, { 'state.currentlyOut': true })
          toastr.info('Boat went out')
        })
      },
      returned() {
        services.reservationService.patch(this.booking._reservation, { status: 'returned' }).then(reservation => {
          for (let booking of reservation.bookings) {
            services.bookingService.patch(booking._id, { status: 'returned' })
          }
          services.boatService.patch(this.booking._boat, { 'state.currentlyOut': false })
          toastr.info('Boat has returned')
        })
      },
      viewDetails() {
        this.$emit('triggerDetails', this.booking.reservation)
      },
      select() {
      }
    },
    props: ['boat', 'hour', 'hours', 'date', 'selected', 'hourIndex', 'move', 'create', 'settings', 'updatedBooking', 'allBookings']
  }
</script>

<style scoped>
  td {
    padding: 0 !important;
    overflow: visible !important;
    cursor: pointer !important;
  }

  .booking-field {
    width: 100%;
    padding-top: 2px;
    text-align: center;
    min-height: 70px;
    height: 100%;
  }

  .reserved {
    background-color: #688ac4;
  }

  .reserved.unconfirmed {
    background-color: #86a9e7;
  }

  .readyToGo {
    background-color: #318a2b;
  }

  .boatOut {
    background-color: #bf783c;
  }

  .returned {
    background-color: #5b7577;
  }

  .blocked {
    background-color: #676767;
  }

  .selected {
    background-color: #B0BEC5 !important;
  }

  .moving, .create-selected {
    background-color: #ee972c;
  }

  .ui.dropdown .menu {
    z-index: 1000;
  }

  .booking-field p {
    text-align: center;
    color: #ffffff;
    font-size: 11px;
    margin-bottom: -1px;
  }

  .dimmed.dimmable > .ui.simple.dimmer {
    width: 120%;
    height: 120%;
    position: absolute;
    font-size: 11px;
    transform: translate(-8.333%, -8.333%);
    z-index: 1000;
    background-color: rgba(38, 59, 102, 0.8) !important;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }

  .ui.dimmer {
    background-color: rgba(38, 59, 102, 0.6)
  }

  p {
    margin-bottom: 2px;
  }

  .service.letter {
    /*margin-right: 3px;*/
    font-size: 13px;
    color: #fff;
    border-right: 1px solid #fff;
    width: 25px;
  }
</style>



// WEBPACK FOOTER //
// BookingChoice.vue?28695bf9